import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import { LOCALE_ES } from '../../../../utils/constants'
import { getLogoSrc } from '../../../../utils/utils'
import { useSelector } from 'react-redux'

const TitleBar = () => {
  const brand = useSelector((state) => state.reducer.brand)

  const useStyles = makeStyles((theme) => ({
    imgHeaderDiv: {
      padding: theme.spacing(2, 4)
    },
    logo: {
      margin: theme.spacing(1),
      maxHeight: brand?.imageLogos.needBigLogos ? 'auto' : 45,
      [theme.breakpoints.down('sm')]: {
        maxHeight: brand?.imageLogos.needBigLogos ? 'auto' : 32,
        height: brand?.imageLogos.needBigLogos ? 60 : 'auto'
      },
      height: brand?.imageLogos.needBigLogos ? 80 : 'auto'
    },
    bigLogo: {
      height: 80,
      [theme.breakpoints.down('md')]: {
        maxHeight: 60
      }
    },
    userMenus: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2)
    }
  }))
  const classes = useStyles()
  const logoSrc = getLogoSrc(brand?.imageLogos?.logoHeader)
  const language = localStorage.getItem('locale') || LOCALE_ES

  return (
    <Grid container className={classes.imgHeaderDiv}>
      <Grid item xs={10}>
        <a href={brand?.linksData.links.headerLinkIndividualClient[`url${language.toUpperCase()}`]}>
          {brand?.imageLogos?.logoHeader && (
            <img id='logo' alt='' src={logoSrc} className={classes.logo} />
          )}
        </a>
      </Grid>
    </Grid>
  )
}

TitleBar.propTypes = {
  locale: PropTypes.string,
}

TitleBar.defaultProps = {
  locale: LOCALE_ES,
}

export default TitleBar
